import React from "react";
import BasePopup from "../Popup/index";
import bgPopupCongratu from "../../../../../assets/images/Mini-Game/bg-popup-congratu1.png";
import bgPopupCongratuEn from "../../../../../assets/images/Mini-Game/bg-popup-congratu1-en.png";
import styled from "styled-components";
import bgButton from "../../../../../assets/images/Mini-Game/bg-button-change.png";
import { useDispatch, useSelector } from "react-redux";
import {
  setOpenPopupFooter,
  setOpenPopupPuzzle,
} from "../../../../../Redux/futures/mini-game/action";
import { curStateMiniGame } from "../../../../../Redux/selector";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";
import { useNavigate } from "react-router";
import PATH from "../../../../../config/PATH";
import { ID_TAB_MINI_GAME } from "../../../../../helper/const";
import { useTranslation } from "react-i18next";

export default function PopupCongratulaPuzzle({ isOpen = true, className }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);
  const onCancel = () => {
    dispatch(
      setOpenPopupFooter({
        isShowPopup: false,
        step: null,
      })
    );

    dispatch(
      setOpenPopupPuzzle({
        isShow: false,
        data: null,
      })
    );
  };

  const navigate = useNavigate();
  const bg_lang_bgPopupCongratu = i18n.language === 'en' ? bgPopupCongratuEn : bgPopupCongratu

  return (
    <BasePopup
      BasePopup
      open={true}
      className={className}
      onCancel={onCancel}
      getContainer
    >
      <Container className="popup-cong-mini">
        <img
          src={iconClosePopup}
          alt=""
          className="rule-mini-close congratula-btn-close scale-hover-item"
          onClick={onCancel}
        />
        <img src={bg_lang_bgPopupCongratu} alt="" className="bg-popup" />
        <div className="popup-cong-mini-main">
          <div className="container-popup-cong-mini-main">
            <div className="content-main">
              {t("mini_game.pop_up_congrats_take_prize.title.prefix")}
            </div>
            <div className="content-main">
              {t("mini_game.pop_up_congrats_take_prize.title.suffix").replace(
                "X",
                dataMiniGame?.popupPuzzle?.data?.prizeName || "XXXXXXXXX"
              )}
            </div>
            <div className="img-prize">
              <img src={dataMiniGame?.popupPuzzle?.data?.image} alt="" />
            </div>
            <div className="content-coins">
              {dataMiniGame?.popupPuzzle?.data?.prizeName || "5,000 MMK"}
            </div>
            <div
              className="button-action-cong"
              onClick={() => {
                onCancel();
                navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
              }}
            >
              <img src={bgButton} alt="" />
              <div className="button-action-cong-content">
                {t("mini_game.pop_up_received_coins.earn_more_pieces")}
              </div>
            </div>

            <div className="content-footer">
              {t("mini_game.pop_up_congrats_take_prize.sub")}
            </div>
            <div className="content-footer">
              {t("mini_game.pop_up_congrats_take_prize.sub_trailing")}
            </div>
          </div>
        </div>
      </Container>
    </BasePopup>
  );
}

// const Container = styled.div`
//   position: relative;

//   .congratula-btn-close {
//     position: absolute;
//     right: 10px;
//     top: 140px;
//   }

//   .button-action-cong {
//     position: relative;
//     margin-bottom: 10px;

//     .button-action-cong-content {
//       position: absolute;
//       top: calc(50% - 4px);
//       left: 50%;
//       transform: translate(-50%, -50%);
//       color: white;
//       font-size: 16px;
//       font-weight: 500;
//       width: 100%;
//     }
//     img {
//       width: 300px;
//       height: 50px;
//     }
//   }

//   .img-prize {
//     text-align: center;
//     margin: 10px 0;

//     img {
//       height: 150px;
//       width: auto;
//     }
//   }

//   .button-action-cong {
//     text-align: center;
//   }

//   .popup-cong-mini-main {
//     position: absolute;
//     z-index: 2;
//     top: 315px;
//     width: calc(75%);
//     padding-right: 8px;
//     left: 50%;
//     transform: translateX(-50%);
//   }

//   .content-main,
//   .content-coins,
//   .content-footer {
//     color: #64310b;
//     font-size: 16px;
//     text-align: center;
//     font-weight: 500;
//   }

//   .content-footer {
//     font-style: italic;
//     font-weight: 400;
//     font-size: 14px;
//   }

//   .content-coins {
//     font-size: 38px;
//     font-weight: 400;
//     margin: 10px 0;
//     font-family: "Ganache", sans-serif;
//     font-style: italic;
//     color: rgba(149, 73, 17, 1);
//     text-shadow: -3px -3px 0 #fff, 3px -3px 0 #fff, -3px 3px 0 #fff,
//       3px 3px 0 #fff;
//       line-height: 40px;
//   }

//   @media (min-width: 992px) {
//     .button-action-cong {
//       &:hover {
//         cursor: pointer;
//         scale: 1.03;
//         transition: 0.3s ease-in-out;
//       }
//     }
//   }

//   @media (max-width: 576px) {
//     .bg-popup {
//       height: 700px;
//     }

//     .popup-cong-mini-main {
//       top: 250px;
//       padding-right: 47px;
//     }

//     .content-footer{
//       font-size: 12px;
//     }

//     .content-coins{
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//   }

//   @media (max-width: 525px) {
//     .img-prize {
//       img {
//         height: 130px;
//       }
//     }

//     .content-footer {
//       font-size: 13px;
//     }

//     .popup-cong-mini-main {
//       top: 270px;
//       padding-right: 8px;
//     }

//     .content-coins {
//       font-size: 25px;
//     }
//   }

//   @media (max-width: 492px) {
//     .content-main {
//       font-size: 14px;
//     }

//     .content-coins{
//       margin: 5px 0;
//     }

//     .button-action-cong{
//       margin-bottom: 5px;
//     }

//     .img-prize {
//       img {
//         height: 100px;
//       }
//     }

//     .content-coins {
//       font-size: 36px;
//     }

//     .content-footer {
//       font-size: 12px;
//     }

//     .content-coins {
//       font-size: 22px;
//     }
//   }

//   @media (max-width: 452px) {
//     .button-action-cong {
//       img {
//         width: 275px;
//       }
//     }

//     .content-coins {
//       font-size: 21px;
//     }
//   }

//   @media (max-width: 436px) {
//     .button-action-cong {
//       &-content {
//         font-size: 16px !important;
//       }
//       img {
//         height: 45px;
//       }
//     }

//     .content-coins {
//       font-size: 20px;
//     }

//     .content-footer {
//       font-size: 11px;
//     }

//     .popup-cong-mini-main {
//       top: 275px;
//     }
//   }

//   @media (max-width: 412px) {
//     .bg-popup {
//       height: 600px;
//     }
//     .button-action-cong {
//       &-content {
//         font-size: 15px !important;
//       }
//       img {
//         width: 225px;
//       }
//     }
//     .img-prize {
//       img {
//         height: 80px;
//       }
//     }
//      .button-action-cong img {
//         height: 38px;
//     }
//     .popup-cong-mini-main {
//       top: 220px;
//       padding: 10px;
//     }
//     /* .img-prize{
//       padding-top: 8px;
//     } */

//     .congratula-btn-close {
//       top: 100px;
//     }
//   }

//   @media (max-width: 392px) {
//     .content-footer {
//       font-size: 9px;
//     }
//   }

//   @media (max-width: 386px) {
//     .popup-cong-mini-main {
//       top: 230px;
//     }
//   }

//   @media (max-width: 375px) {
//     .content-main {
//       font-size: 13px;
//     }
//     .button-action-cong {
//       &-content {
//         font-size: 14px !important;
//       }
//       img {
//         height: 40px;
//       }
//     }
//   }

//   @media (max-width: 345px) {
//     .content-main {
//       font-size: 11px;
//     }
//   }
// `;

const Container = styled.div`
  position: relative;
  top: -200px;
  left: -10px;

  .congratula-btn-close {
    position: absolute;
    right: 10px;
    top: 140px;
    z-index: 3;
  }

  .content-main,
  .content-coins,
  .content-footer {
    color: #64310b;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
  }

  .popup-cong-mini-main {
    position: relative;
    z-index: 2;
    top: 260px;
    width: 74%;
    left: 50%;
    transform: translateX(-50%);
  }

  .container-popup-cong-mini-main {
    left: -1.5%;
    position: relative;
    padding-top: 60px;
  }

  .img-prize {
    text-align: center;
    margin: 10px 0;

    img {
      height: 150px;
      width: auto;
    }
  }

  .bg-popup {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    height: calc(100% + 315px);
  }

  .button-action-cong {
    position: relative;
    margin-bottom: 10px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;

    .button-action-cong-content {
      position: absolute;
      top: calc(50% - 4px);
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 16px;
      font-weight: 500;
      width: 100%;
    }
    img {
      width: 300px;
      height: 50px;
    }
  }

  .content-footer {
    font-style: italic;
    font-weight: 400;
    font-size: 14px;
  }

  .content-coins {
    font-size: 38px;
    font-weight: 400;
    margin: 10px 0;
    font-family: "Ganache", sans-serif;
    font-style: italic;
    color: rgba(149, 73, 17, 1);
    text-shadow: -3px -3px 0 #fff, 3px -3px 0 #fff, -3px 3px 0 #fff,
      3px 3px 0 #fff;
    line-height: 40px;
  }

  @media (max-width: 768px) {
    left: 3px;
    .content-main {
      font-size: 14px;
    }

    .content-coins {
      font-size: 28px;
      line-height: 34px;
    }

    .button-action-cong .button-action-cong-content {
      font-size: 14px;
    }

    .button-action-cong img {
      width: 80%;
      min-height: 40px;
      height: auto;
    }

    .content-footer {
      font-size: 12px;
    }
  }

  @media (max-width: 576px) {
    .content-coins {
      font-size: 22px;
      line-height: 26px;
    }

    .button-action-cong-content {
      font-size: 14px;
    }

    .button-action-cong img {
      width: 90%;
      min-height: 40px;
      height: auto;
    }

    .content-main {
      font-size: 13px;
    }

    .content-footer {
      font-size: 11px;
    }

    .button-action-cong {
      margin-bottom: 6px;
    }

    .content-coins {
      margin: 6px 0;
      margin-top: 0;
    }

    .img-prize {
      margin: 6px 0;
    }
  }

  @media (max-width: 470px) {
    .container-popup-cong-mini-main {
      padding-top: 30px;
    }

    .popup-cong-mini-main {
      width: 73%;
    }
  }
`;
